import { render } from "./LabeledTooltip.vue?vue&type=template&id=23a32d2e&ts=true"
import script from "./LabeledTooltip.vue?vue&type=script&lang=ts"
export * from "./LabeledTooltip.vue?vue&type=script&lang=ts"

import "./LabeledTooltip.vue?vue&type=style&index=0&id=23a32d2e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__